<template lang="pug">
.v-product-card.product-card(v-if="data" )
	.product-card__background(:style="{background: `center / cover no-repeat url(${backgroundComputed})`}")
	.product-card__blackout
	a.product-card__link(v-if="data.href" :href="data.href")
	.product-card__top
		.product-card_top-image(v-if="data.imageTop")
			img(:src="data.imageTop?.src"
				:alt="data.imageTop?.alt")
		.product-card_top__tags(v-if="data.tags" )
			.product-card_top-tag__tag.tag(v-for="(tag, index) in data.tags" :key="index" )
				.tag__text(v-if="tag.text" ) {{ tag.text }}
	.product-card__main
		.product-card__main-name(v-if="data.name" ) {{ data.name }}
		h5.product-card__main-title(v-if="data.title" ) {{ data.title }}
		.product-card__main-image(v-if="data.imageMain" :class="data.imageMain.className ? data.imageMain.className : ''")
			img(:src="data.imageMain?.src"
				:alt="data.imageMain?.alt")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	},

	computed: {
		backgroundComputed() {
			return this.data?.imageMain?.src ? this.data.imageMain.src : '#0E0E0F'
		}
	}
}

</script>